const cookieparser = process.server ? require('cookieparser') : undefined
import {logWrapper} from "../utils/logWrapper";

// This plugin checks the server version and clears localStorage if it has changed,
// to avoid issues with stale data after a deployment.
// Same as CP, if you change this, also change it in CP as well.
async function checkVersionAndClean() {
  const lastChecked = localStorage.getItem('lastCheckedVersion') || 0;

  if (process.client) {
    const now = Date.now()

    // Only check every 10s to avoid too many requests
    if (now - lastChecked < 10000) return

    let serverVersion;
    try {
      const res = await fetch('/__version', { cache: 'no-store' })
      const data = await res.json()
      serverVersion = data.version
    } catch (err) {
      logWrapper.logError('Could not fetch server version', err)
      return
    }

    const storedVersion = localStorage.getItem('appVersion')

    if (serverVersion && storedVersion !== serverVersion) {
      logWrapper.logInfo('Version changed, clearing data and reloading')

      localStorage.clear()
      sessionStorage.clear()

      document.cookie.split(";").forEach(cookie => {
        document.cookie = cookie
          .replace(/^ +/, "")
          .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`)
      })

      localStorage.setItem('appVersion', serverVersion)
      window.location.reload()
    }
  }
}

export default function ({$axios, store, req}) {

  $axios.onRequest((config) => {
    checkVersionAndClean();

    if (!process.server) {
      if (!config.url.includes('Dashboard')) {
        store.commit('setLoading', {loading: true})
      }
    }
    if (config.url.includes('refreshtoken')) {
      if (!process.server) {
        try {
          config.data.token = localStorage['auth._token.local'].replace(
            'Bearer ',
            ''
          )
        } catch (err) {
          logWrapper.logError(`Error accessing localStorage for refreshtoken: ${err}`);
        }
      }
      if (process.server) {
        if (req.headers.cookie) {
          const parsedCookie = cookieparser.parse(req.headers.cookie)
          try {
            config.data.token = parsedCookie['auth._token.local'].replace(
              'Bearer ',
              ''
            )
          } catch (err) {
            logWrapper.logError(`Error parsing cookie for refreshtoken: ${err}`);
          }
        }
      }
    }

    logWrapper.logInfo(`Making request to ${config.url}`);
  })

  $axios.onResponse((response) => {
    if (!process.server) {
      store.commit('setLoading', {loading: false})
    }
  })

  $axios.onError((error) => {
    if (!process.server) {
      store.commit('setLoading', {loading: false})
    }
    const code = parseInt(error?.response && error?.response?.status)

    logWrapper.logError(`axios error with code: ${code} - ${error}`);
  })
}
